import React,{useState} from "react";
// import { Card, CardHeader, Container, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
  
} from "reactstrap";
import SubAdminPermission from "./SubAdminPermission";
import { helper } from "lib/helper";
import SubAdminModal from 'models/user.modal'

const AddUser = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [mobile,setmobile]= useState("");
  const[activepermission, setActivePermission] = useState(false)
  console.log("mobile",mobile);
  const navigate = useNavigate();
  
  
  
  
  
  const handleSubmit = (event) => {
    event.preventDefault();
    setAddsLoadig(true);
    
    const form = new FormData(event.target);

   
    SubAdminModal
      .create(form)
      .then((response) => {
         console.log(response, "fqAdd");
         if(response?.data.is_error == false){
        setActivePermission(true)}
        if(response?.data.is_error == true){
          helper.sweetalert.toast(response.data.message, "warning"); 
        }
        if(response?.data.is_error == false){
          helper.sweetalert.toast(response.data.message, "success");}
       // navigate("/admin/user");
        setAddsLoadig(false);
        // getListData();
        // toggleModal();
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error);
      });
  };
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              {!activepermission &&
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Add User</h3>
              </CardHeader>}
              <CardBody> {!activepermission &&
              <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Name</Label>
                          <Input
                          required
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="name"
                            placeholder="Enter Name"
                          />
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Profile Image</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="profile_pic"
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Phone No.</Label>
                          <Input id="Priority" 
                          required
                           name="mobile" 
                           type="number" 
                           placeholder="Enter Phone Number" 
                           value={mobile} 
                           onChange={(e)=>setmobile(e.target.value)} />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <Label for="exampleEmail">Email*</Label>
                          <Input
                          required
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Enter email"
                          />
                        </FormGroup>
                      </Col>

                      <Col md={4}>
                      <FormGroup>
                          <Label for="exampleEmail">Designation <span style={{color:"lightgray"}}>eg.supervisor</span></Label>
                          <Input
                            id="Desginatio"
                            name="designation"
                            type="text"
                            placeholder="*Enter Designation"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                      <FormGroup>
                          <Label for="exampleEmail">Password</Label>
                          <Input
                            id="password"
                            name="password"
                            type="password"
                            placeholder="*Enter Password"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                   
                    <Row className="mb-2" style={{display:"flex",justifyContent:"flex-end"}}>
                     <Col md={2} >
                    <Button style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white"}}  >
                        Submit
                      </Button>
                      </Col>
                     
                    </Row>
                    </Form>}
                  {activepermission &&
                    <Row>
                      <Col md={12}>
                        <SubAdminPermission mobile={mobile}/>
                      </Col>
                    </Row>
                  }
                  </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AddUser;
